module.exports = __webpack_public_path__ + "img/permission_img01.7c84bc79.png";